import exportsApi from '@/api/exports'

export const weighingNoteAvailable = function (order) {
  return (
    order.company.settings.enable_weighing_notes &&
    this.order.type == 'EmptyingOrder' &&
    (this.order.status == 'done' || this.order.status == 'closed') &&
    this.order.billing &&
    this.order.material_weight_kg > 0
  )
}

export const createWeighingNoteExport = async function (order) {
  await exportsApi.create({
    type: 'weighing_note_pdf',
    company_uuid: order.company.uuid,
    order_uuid: order.uuid,
  })
}
